import React from 'react';
import { Alert as MuiAlert } from '@mui/material';

function Alert({ children, variant = 'error', onClose }) {
  const severityMap = {
    error: 'error',
    success: 'success',
    warning: 'warning',
    info: 'info'
  };

  return (
    <MuiAlert 
      severity={severityMap[variant]} 
      onClose={onClose}
      className="mb-4"
    >
      {children}
    </MuiAlert>
  );
}

export default Alert;
